import { Link } from 'react-router-dom';
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Notification from '../../notification/Notification'; 
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useClickOutside from '../hooks/useClickOutside';
import { useState } from 'react';

const NavbarRight = ({ currentUser, notificationOpen, setNotificationOpen, closeUserDropdown, children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);    

    const menuRef = useClickOutside(() => {
        setIsMenuOpen(false);
    });

    return (
        <div className="right">
            <div ref={menuRef} className="hamburger-wrapper">
                <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {isMenuOpen ? <CloseOutlinedIcon /> : <MenuOutlinedIcon />}
                </div>

                <div className={`menu-container ${isMenuOpen ? 'open' : ''}`}>
                    <div className="icons">
                        <Link 
                            to={`/friendList/${currentUser.id}`} 
                            style={{ textDecoration: "none", color: "inherit" }}
                        >
                            <PersonOutlinedIcon />
                        </Link>

                        <Link 
                            to={`/chat/${currentUser.id}`} 
                            style={{ textDecoration: "none", color: "inherit" }}
                        >
                            <EmailOutlinedIcon />
                        </Link>

                        <Notification
                            isNotificationOpen={notificationOpen}
                            setNotificationOpen={setNotificationOpen}
                            closeUserDropdown={closeUserDropdown}
                        />
                    </div>
                </div>
            </div>

            {children}
        </div>
    );
};
export default NavbarRight;